<template lang="pug">
  v-layout.popup-proyeccion-vidafree
    PopupAlertMessage(
      @closeAlertPopup="methodClosePopupAlert"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
      )
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando PDF...
          v-progress-linear.mb-0(indeterminate="" color="white")
    v-dialog(v-model="openPopupInfo" persistent width="300")
      v-card(style="display: flex;flex-direction: column;justify-content: center; border-radius:5px")
        v-card-text.pt-3.pb-1
          v-flex(style="text-align:center")
            span {{message}}
        v-card-actions.py-3
          v-flex(style="text-align:center")
            v-btn(@click="openPopupInfo=false" color="#EA0D90" style="width:10rem;height:2.7rem;border-radius:5px")
              span(style="color:#fff;text-transform:Capitalize" ) ok
    v-dialog(v-model="openPopup" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card
        v-toolbar(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
            v-icon keyboard_backspace
          v-toolbar-title
            span(style="color: #ffffff; font-size: 20px;") Proyección
        v-card-text(style="padding: 1em 1.5em;")
          v-layout.box-proyeccion-desktop-formatter(style="position:relative" column align-center)
            v-dialog(v-model="loader" persistent width="300")
              v-card(color="primary" dark="")
                v-card-text
                  | Descargando PDF...
                  v-progress-linear.mb-0(indeterminate="" color="white")
            PopupAlertMessage(
              @closeAlertPopup="popupAlert.openPopup = !$event"
              :openPopup="popupAlert.openPopup"
              :image="popupAlert.image"
              :title="popupAlert.title"
              :message="popupAlert.message"
              :messageButton="popupAlert.messageButton"
              :buttonClose="popupAlert.buttonClose"
              :imgHeight="popupAlert.imgHeight"
              :imgWidth="popupAlert.imgWidth"
                )
            v-flex(style="margin:1em")
              span(style="font-size: 16px;color: #454A6C;") {{ title }}
            v-flex
              v-layout(column align-center style="position:relative")
                v-flex
                  v-img
                    img#box-icon-proyeccion(
                      :src="iconView"
                      style="height: 200px;width: 200px;"
                      )
                v-flex(:style="`position: absolute; ${producto !== 'PLANGARANTIZADO' ? 'top: 2em;' : 'top: 4em;'} text-align: center;transform: scale(1.2, 1.4) !important;`")
                  span#box-monto-proyeccion(:style="producto !== 'PLANGARANTIZADO' ? '' : 'color:#ffffff !important; text-shadow: 0px 4px 4px #027667;'") {{montoProyeccion || ''}}
                v-flex(style="position: absolute;bottom: 1em;width: 8em;text-align: center;line-height: 12px;")
                  span(style="color: #454A6C; font-size: 11px")
                    b Aquí verás tu proyección
            v-flex(style="margin:1em" v-if="producto == 'PLANGARANTIZADO'")
              BoxTitleMonto(
                :title="producto !== 'PLANGARANTIZADO' ? 'Monto de devolución ':'Monto Asegurado'"
                :mensaje="tipoMoneda + (montoAsegurado || '0')"
                )
            v-flex.box-select-proyeccion-formatter(style="width: 15em;")
              v-select(
                :items="items"
                label="Periodo anual"
                @input="periodoSeleccionadoMethod"
                solo
                )
            v-flex(style="margin:0.5em auto")
              v-btn(@click="calcularProyeccion()" color="#EA0D90" style="height: 3.3em;width: 15em;")
                span(style="text-transform: none; color: #ffffff; font-size: 15px;") Calcular
            v-flex(style="width: 19em; text-align: center;margin:1em 0em")
              span(style="color: #454A6C;font-size: 16px;") Quiero descargar mi cuadro de resumen &nbsp;
                b(@click="valoresGarantizadosDonwload" style="color: #0855C4;text-decoration-line: underline;cursor:pointer") aquí

</template>

<script>
import * as d3 from 'd3'
import BoxTitleMonto from '../../components/generic/BoxTitleMonto.vue'
import { mapActions } from 'vuex'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import Transacts from '../../interfaces/transacts'

export default {
  props: [
    'openPopup',
    'montoAsegurado',
    'periodoDePago',
    'periodos',
    'tipoMoneda',
    'inicioVigencia',
    'taggeo',
    'numeroPoliza',
    'producto',
    'oriProducto'
  ],
  data () {
    return {
      iconView: null,
      gifView: null,
      gifPG: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion3.gif'),
      iconPG: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion1.svg'),
      gifVF: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf.gif'),
      iconVF: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf.svg'),
      items: [],
      valoresGarantizados: this.periodos,
      montoProyeccion: '',
      periodoSeleccionado: null,
      proyecciones: 0,
      loader: false,
      title: '',
      openPopupInfo: false,
      message: '',
      popupAlert: {
        openPopup: false,
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        imgHeight: 150,
        imgWidth: 150
      },
      metadata: {}
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    ...mapActions('user', ['getPDFTablaValoresGarantizados', 'getPDFTablaRescates']),

    methodClosePopup () {
      let self = this
      self.openPopup = false
      self.eventLog({
        'tipoDocumento': self.taggeo.tipoDocumento,
        'numeroDocumento': self.taggeo.numeroDocumento,
        'categoria': 'Consulta',
        'nombre': self.taggeo.nombre,
        'datos': {
          'numero_de_Poliza': self.taggeo.numeroPoliza,
          'cuotas_Pendientes': 'NO',
          'antiguedad': self.periodoActual === undefined ? '01' : self.periodoActual.anho,
          'proyecciones': self.proyecciones,
          'producto_Consultado': self.taggeo.ramo,
          'subproducto_Consultado': self.taggeo.nombreProducto,
          'navegacion': 'Proyección',
          'dispositivo': 'mobile'
        }
      })

      this.$emit('closePopup', 'proyeccion')
    },
    methodClosePopupAlert () {
      this.popupAlert.openPopup = false
      if (this.popupAlert.back) {
        this.$emit('closePopup', '')
      }
    },
    calcularProyeccion () {
      if (this.periodoSeleccionado) {
        let anio = this.periodoSeleccionado.split('años', 1)
        // filtrando proyeccion seleccionada
        this.proyeccionSeleccionada = this.valoresGarantizados.filter(dato => Number(dato.anho) === Number(anio[0]))
        // formateando monto
        const monto = (this.producto.toLowerCase().includes('free')) ? this.proyeccionSeleccionada[0].rescate : ((this.producto || '').includes('VIDACASH') || (this.producto || '').toLowerCase() === Transacts.products.RUMBO || (this.oriProducto || '').toLowerCase() === Transacts.products.RUMBO ? this.proyeccionSeleccionada[0].rescate : this.proyeccionSeleccionada[0].sumaAsegurada)
        let auxMonto = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(monto)
        this.montoProyeccion = this.tipoMoneda + auxMonto

        let iconProyeccion = document.querySelector('#box-icon-proyeccion')
        iconProyeccion.src = this.gifView

        let montoProyeccion = d3.select('#box-monto-proyeccion')
        montoProyeccion.style('opacity', 0)
        montoProyeccion.transition().delay(2700).duration(800)
          .style('opacity', 1)

        // CONTANDO PROYECCIONES REALIZADAS
        this.proyecciones++
      } else {
        this.popupAlert.openPopup = true
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = 'Debe de seleccionar un periodo'
      }
    },
    periodoSeleccionadoMethod (item) {
      this.periodoSeleccionado = item

      let iconProyeccion = document.querySelector('#box-icon-proyeccion')
      iconProyeccion.src = this.iconView

      let montoProyeccion = d3.select('#box-monto-proyeccion')
      montoProyeccion.transition().duration(500)
        .style('opacity', 0)
    },
    valoresGarantizadosDonwload () {
      let self = this
      self.loader = true
      const thenCallback = res => {
        self.loader = false
      }
      const catchCallback = () => {
        self.loader = false
        self.openPopupInfo = true
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de cuadro de resumen',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (self.producto.toLowerCase().includes('free') || (self.producto || '').includes('VIDACASH')) {
        this.getPDFTablaRescates({ numeroPoliza: this.numeroPoliza }).then(thenCallback).catch(catchCallback)
      } else {
        this.getPDFTablaValoresGarantizados({ numeroPoliza: this.numeroPoliza }).then(thenCallback).catch(catchCallback)
      }
    }
  },
  mounted () {
    d3.select('.box-proyeccion-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    let self = this

    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Proyección', metadata: self.metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Proyección',
        'dispositivo': 'mobile'
      }
    })

    if (this.producto !== 'PLANGARANTIZADO') {
      self.title = 'Visualiza cómo crecen tus ahorros más tu rentabilidad en el futuro, si no llega a ocurrir algún siniestro.'
      self.iconView = self.iconVF
      self.gifView = self.gifVF
    } else {
      self.title = 'Visualiza cómo crecen tus ahorros en el futuro.'
      self.iconView = self.iconPG
      self.gifView = self.gifPG
    }

    // ORDERNAR VALORES GARANTIZADOS
    let auxValoresGarantizados = []
    auxValoresGarantizados = (self.valoresGarantizados || []).sort((a, b) => a.anho - b.anho)
    self.items = auxValoresGarantizados.map(data => Number(data.anho) + ' años')

    self.valoresGarantizados = auxValoresGarantizados

    // TIENE INFO TABLA
    if (!self.periodos || self.periodos.length === 0 || self.oriProducto.includes('VIDA_CASH_PLUS')) {
      self.popupAlert.openPopup = true
      self.popupAlert.title = 'Estimado cliente'
      self.popupAlert.message = 'Por el momento no se encuentra activa esta funcionalidad.'
      self.popupAlert.messageButton = 'Entendido'
      self.popupAlert.buttonClose = false
      self.popupAlert.back = true
    }
  },
  components: {
    BoxTitleMonto,
    PopupAlertMessage
  }

}
</script>

<style>
.box-proyeccion-desktop-formatter #box-monto-proyeccion {
  color: var(--text-color);
  font-size: 18px;
  font-weight: bold;
  opacity: 0;
  font-family: "Omnes Medium";
}

.box-select-proyeccion-formatter .v-text-field.v-text-field--solo .v-label {
  top: calc(50% - 9px) !important;
  left: initial !important;
  right: initial !important;
  display: flex;
  justify-content: center;
  width: 100%;
  color: #000000;
  left: 10px !important;
}

.box-select-proyeccion-formatter .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.box-select-proyeccion-formatter .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
  padding: 0 12px;
}

.box-select-proyeccion-formatter .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 2px;
  background: #fff;
  margin: 0;
  box-shadow: 0px 0px 0px 0px !important;
  border: 1px solid #919191;
  border-radius: 3px;
  min-height: 48px !important;
  height: 48px !important;
}

.box-select-proyeccion-formatter .v-select__selection--comma {
  margin: 0em !important;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupProyeccion.vue